(function () {
  'use strict';

  var SECTION_SELECTOR = '.tier-benefits';
  var TAB_SELECTOR = '.tier-benefits__tab[data-tier]';
  var MOBILE_PANEL_SELECTOR = '.tier-benefits__mobile';
  var CELL_SELECTOR = '.tier-benefits__cell[data-tier]';

  function setActiveTier(section, tier) {
    var tabs = section.querySelectorAll(TAB_SELECTOR);
    var cells = section.querySelectorAll(CELL_SELECTOR);
    var panel = section.querySelector(MOBILE_PANEL_SELECTOR);
    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-tier') === tier;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    cells.forEach(function (cell) {
      cell.classList.toggle('tier-benefits__cell--visible', cell.getAttribute('data-tier') === tier);
    });
    if (panel) {
      var activeTab = section.querySelector(TAB_SELECTOR + '.is-active');
      panel.setAttribute('aria-labelledby', activeTab ? activeTab.id : '');
    }
  }

  function handleTabClick(section, event) {
    var tab = event.target.closest(TAB_SELECTOR);
    if (!tab || !section.contains(tab)) return;
    event.preventDefault();
    var tier = tab.getAttribute('data-tier');
    if (tier) setActiveTier(section, tier);
  }

  function initSection(section) {
    if (!section || section.dataset.tierBenefitsInited === 'true') return;
    section.dataset.tierBenefitsInited = 'true';

    if (section.querySelector(TAB_SELECTOR)) {
      section.addEventListener('click', function (e) {
        handleTabClick(section, e);
      });
      setActiveTier(section, 'member');
    }
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector(SECTION_SELECTOR);
      if (section) initSection(section);
    });
  }
})();
